function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom.iterable.js";
import { useState, useEffect, useRef } from 'react';
import { debounce } from 'throttle-debounce';
const HeaderNodes = Object.freeze({
  ROOT: 'header-root',
  NAVIGATION: 'header-nav-container'
});
export const useHeaderObserver = () => {
  const [entry, setEntry] = useState({});
  const rootNodeRef = useRef(null);
  const navigationNodeRef = useRef(null);
  const intersectionHandler = _ref => {
    let [observedEntry] = _ref;
    return setEntry({
      visible: observedEntry.isIntersecting,
      root: {
        clientRect: observedEntry.boundingClientRect
      },
      navigation: {
        clientRect: navigationNodeRef.current.getBoundingClientRect(),
        positionBottom: 'positionBottom' in navigationNodeRef.current.dataset
      }
    });
  };
  const resizeHandler = debounce(166, _ref2 => {
    let [observedEntry] = _ref2;
    return setEntry(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      root: {
        clientRect: observedEntry.contentRect
      },
      navigation: {
        clientRect: navigationNodeRef.current.getBoundingClientRect(),
        positionBottom: 'positionBottom' in navigationNodeRef.current.dataset
      }
    }));
  });
  const intersectionObserverRef = useRef(typeof window !== 'undefined' && new window.IntersectionObserver(intersectionHandler));
  const resizeObserverRef = useRef(typeof window !== 'undefined' && !!window.ResizeObserver && new window.ResizeObserver(resizeHandler));
  useEffect(() => {
    if (!(intersectionObserverRef !== null && intersectionObserverRef !== void 0 && intersectionObserverRef.current) || !(resizeObserverRef !== null && resizeObserverRef !== void 0 && resizeObserverRef.current)) return null;
    rootNodeRef.current = document.querySelector(`#${HeaderNodes.ROOT}`);
    navigationNodeRef.current = document.querySelector(`#${HeaderNodes.NAVIGATION}`);
    if (rootNodeRef.current) {
      intersectionObserverRef.current.observe(rootNodeRef.current);
      resizeObserverRef.current.observe(rootNodeRef.current);
    }
    return () => {
      resizeObserverRef.current.disconnect();
      intersectionObserverRef.current.disconnect();
    };
  }, []);
  return [entry];
};
//# sourceMappingURL=useHeaderObserver.js.map